import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const userService = {
  updateLastVisitedSite: async (siteId: string | null): Promise<void> => {
    await apiClient.put(ENDPOINTS.users.updateLastVisitedSite, { siteId })
  },

  updateOnboardingCompleted: async (completed: boolean): Promise<void> => {
    await apiClient.put(ENDPOINTS.users.updateOnboarding, { completed })
  },
}
